import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import style from '../Chat.module.css';

function UserMessage({ chatInfo, chatVariants }) {
    return (
        <div className={style['user-talk-box']}>
            <p>{chatInfo.text}</p>
            <span className={style['date-txt']}>{chatInfo.chatTime}</span>
        </div>
    );
}

export default React.memo(UserMessage);